import UserMessage from './UserMessage'
import Employee from './Employee'
export class SaveUserMessageRequest {
    UserMessage: UserMessage;
    SavedByEmployee: Employee;
}

export default SaveUserMessageRequest;